import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {TablasDinamicasConfigService} from '../../../services/database/tablas-dinamicas-config.service';
import {
  AccessRole,
  ButtonColumnType,
  CustomTableComponent,
  DataColumnType,
  ICustomTable,
  LoadingPanelService,
  LocalService,
  CustomTitle
} from 'lib-base';
import {TablasDinamicasConfig} from '../../../shared/interfaces/database/tramites_automaticos';
import {firstValueFrom, forkJoin} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ConfirmationService, MessageService} from 'primeng/api';

import {FormDatasetCreacionComponent} from './form-dataset-creacion.component';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {GetDatasetDinamicoDatosComponent} from './get-dataset-dinamico-datos.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-datasets-dinamicos',
  standalone: true,
  imports: [CustomTableComponent, FormDatasetCreacionComponent, ConfirmPopupModule, GetDatasetDinamicoDatosComponent, CustomTitle, TranslateModule],
  providers: [ConfirmationService],
  template: `
    <p-confirmPopup></p-confirmPopup>
    <section class="flex justify-content-center mt-4">
      <div class="card-table col-12">
        <div >
            <CustomTitle [title]="'common.datasetsDinamicos' | translate"
                         styleClass="font-principal app-title-page-color font-medium font-23 mt-4  text-uppercase mb-0"/>
        </div>
        <custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
        </custom-table>
      </div>
      <ng-template #tableRowexpansion let-data>
        <div class="overflow-x-auto max-w-screen">
          <app-get-dataset-dinamico-datos [tablaDinamicaId]="data.id"
                                          [datasetNombre]="data.datasetNombre"
                                          [tablaDinamicaConfig]="data"/>
        </div>

      </ng-template>
    </section>
    <app-form-dataset-creacion (onClose)="onClose()"></app-form-dataset-creacion>
  `,
})
export class DatasetsDinamicosComponent implements OnInit {
  trans: any = {};
  customTable !: ICustomTable;
  role = AccessRole;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(FormDatasetCreacionComponent) formDatasetCreacionComponent !: FormDatasetCreacionComponent;
  private titleService: CustomTitleDirective = inject(CustomTitleDirective);

  constructor(private readonly _tsc: TablasDinamicasConfigService, private readonly _t: TranslateService, private readonly _ms: MessageService,
              private readonly _cs: ConfirmationService, private readonly _lps: LoadingPanelService, public readonly ls: LocalService) {
  }

  ngOnInit(): void {
    this.titleService.changeTitle('common.datasetsDinamicos')
    this.getTablasDinamicas();
    this.translate().then(() => {
      this.configurarTabla();
    });
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      title: this._t.get('common.datasetsDinamicos'),
      datasetNombre: this._t.get('common.datasetNombre'),
      fechaCreacion: this._t.get('common.fechaCreacion'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      msgSuccess: this._t.get('common.success'),
      datasetDesactivado: this._t.get('msg.datasetDesactivado'),
      datasetActivos: this._t.get('msg.datasetActivos'),
      estasSeguroEliminarActividad: this._t.get('msg.estasSeguroEliminarActividad'),
    }));
  }

  private configurarTabla(): void {
    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '3.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'datasetNombre',
          header: this.trans.datasetNombre,
          sort: true, class: 'font-13',
          width: "100%",
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaCreacion',
          header: this.trans.fechaCreacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          width: '13rem',
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '13rem',
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'edit',
          header: '',
          width: '4.5rem',
          class: 'pt-2 pb-2 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: TablasDinamicasConfig) => this.openEditModal(data),
        },
        {
          field: 'estado',
          header: '',
          width: '4.8rem',
          class: 'button-edit p-button-outlined',
          buttonType: ButtonColumnType.CHECK,
          onClick: (event: Event, data: TablasDinamicasConfig) => this.updateEstado(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal()
          },
        }
      ],
      settings: {
        table: {
          rows: 7,
          scrollable: false,
          tableStyle: {'table-layout': 'fixed'} as { [p: string]: any }
        }
      }
    } as ICustomTable;
  }

  private openNewModal(): void {
    this.formDatasetCreacionComponent.open();
  }

  private openEditModal(data: TablasDinamicasConfig) {
    this.formDatasetCreacionComponent.openEdit(data);
  }


  onClose(): void {
    this.getTablasDinamicas();
  }

  updateEstado(event: Event, data: TablasDinamicasConfig) {
    if (data.estado) {
      this._cs.confirm({
        target: event.target as EventTarget,
        message: this.trans.estasSeguroEliminarActividad,
        icon: 'pi pi-exclamation-triangle',
        accept: () => this.desactivarDataSet(data.id, this.trans.datasetDesactivado),
        reject: () => {
        }
      });
    } else {
      this.desactivarDataSet(data.id,this.trans.datasetActivos)
    }

  }

  private desactivarDataSet(id: number, message:string) {
    this._lps.show(true);
    this._tsc.desactivar(id).subscribe(() => {
      this._ms.add({
        severity: 'success',
        summary: this.trans.success,
        detail: message
      });
      this.getTablasDinamicas();
      this._lps.hide();
    });
  }

  private getTablasDinamicas(): void {
    this._tsc.getTablasDinamicas().subscribe((data: TablasDinamicasConfig[]) => {
      this.customTableComponent.data = data;
    });
  }
}
